module.exports = require("core-js/modules/es.array.slice.js");